import React from "react";
import ModalBackdrop from "components/ModalBackdrop";
import { getSmartDocWorkflow } from "./workflowRegistry";

export default function SmartDocDialog({ isOpen, onClose, workflowCode, context, onComplete }) {
  if (!isOpen) return null;
  const Workflow = getSmartDocWorkflow(workflowCode)?.component;
  return <ModalBackdrop onClose={onClose} zIndex="z-[1100]">
    <div className="flex max-h-[94vh] flex-col rounded-xl border border-border bg-app shadow-2xl">
      <div className="flex items-start justify-between border-b border-border px-5 py-3"><div><h2 className="text-lg font-semibold text-brand">SmartDoc</h2><div className="text-xs text-muted">Deterministic document import</div></div><button type="button" className="btn btn-ghost" onClick={onClose}>Close</button></div>
      <div className="overflow-auto p-4">{Workflow ? <Workflow context={context} onComplete={onComplete} /> : <div className="text-sm text-red-700">Unknown SmartDoc workflow.</div>}</div>
    </div>
  </ModalBackdrop>;
}
